import _import_ from "@assets/js/pub_import.js";
const BASE_URL = "pageIndex";
export default [
  {
    path: "/home",
    component: _import_(BASE_URL + "/exhibition.vue")
  }
];
